export enum SurveyTypes {
  EarlyAccessFamilyEngagementSurvey = 'EarlyAccessFamilyEngagementSurvey',
  SpecialEducationFamilyEngagementSurvey = 'SpecialEducationFamilyEngagementSurvey',
  Fgrbi = 'FGRBI',
}
